// This is the Laura entry point file.
// There should be no custom code written directly in this file.

import './utils/preact-error-guard'; // Must stay first
import './melanielyne.main.css';
import './utils/accordion';
import './utils/localization';
import './utils/local-price-format';
import './utils/loyalty-service';
import './utils/lazy-image';
import './utils/kustomer-loader';
import './cart/cart-label-global'; // Initialize cart label global functions
import Global from './utils/global';
import initCartSync from './cart-sync';

window.STOREFRONT = 'ML';

// Load any global js functionality
Global();
initCartSync();
